module.exports = __webpack_public_path__ + "img/181.service.b0674cf8.svg";